import { useLocation } from 'react-router-dom';

import { Collapse } from '@uptime/design-system/components/Collapse';
import { List } from '@uptime/design-system/components/List';
import { ListItem } from '@uptime/design-system/components/ListItem';
import { ListItemButton } from '@uptime/design-system/components/ListItemButton';
import ExpandLessIcon from '@uptime/design-system/icons/ExpandLessIcon';
import ExpandMoreIcon from '@uptime/design-system/icons/ExpandMoreIcon';
import { useThemeV7 } from '@uptime/design-system/MUIv7Exports';

interface Props {
  pathname: string;
  isActive: (pathname: string, extraActive?: boolean) => boolean;
  onClick: (pathname: string, isActiveItem?: boolean) => void;
  children: React.ReactNode;
  main: React.ReactNode;
  activeOverride?: boolean;
}

export const CollapsableListItem = ({
  children,
  onClick,
  main,
  pathname,
  isActive,
  activeOverride,
}: Props) => {
  const location = useLocation();
  const theme = useThemeV7();
  const isOpened = isActive(pathname);
  const anyActiveChild = activeOverride ?? location.pathname.startsWith(pathname);

  return (
    <>
      <ListItem disablePadding data-testid="leftMenuItem">
        <ListItemButton
          variant="sidebar"
          onClick={() => onClick(pathname, anyActiveChild)}
          sx={
            anyActiveChild
              ? {
                  '&&:hover .MuiListItemIcon-root .MuiSvgIcon-root': {
                    color: theme.palette.grey.white,
                  },
                }
              : isOpened
                ? { '&&:hover .MuiListItemIcon-root': { color: theme.palette.primary.main } }
                : undefined
          }
        >
          {main}
          {isOpened ? (
            <ExpandLessIcon data-testid="KeyboardArrowUpIcon" />
          ) : (
            <ExpandMoreIcon data-testid="KeyboardArrowDownIcon" />
          )}
        </ListItemButton>
      </ListItem>
      <Collapse in={isOpened} timeout="auto" unmountOnExit>
        <List component="div" disablePadding>
          {children}
        </List>
      </Collapse>
    </>
  );
};
